import { h } from 'preact';

import Modal from 'widget_main/components/Modal';
import TextArea from 'widget_main/components/TextArea';
import Button from 'widget_main/components/Button';
import CheckCircleIcon from 'widget_main/globals/assets/checkCircle.svg';
import { useTranslations } from 'i18n/hooks';

import styles from './satisfactionMessageModal.scss';
import { MAX_ANSWER_LENGTH } from './constants';
import messages from './messages';

interface SatisfactionMessageModalProps {
  modalContent?: 'success' | 'feedback';
  onSubmit: () => void;
  onHide: () => void;
  setFollowupAnswer: (event: Event) => void;
  followupAnswer?: string;
  followupQuestion?: string;
}

const SatisfactionMessageModal = ({
  modalContent,
  onSubmit,
  onHide,
  followupAnswer,
  followupQuestion,
  setFollowupAnswer,
}: SatisfactionMessageModalProps) => {
  const isFeedback = modalContent === 'feedback';
  const translations = useTranslations(messages, ['done']);

  return (
    <Modal
      className={styles.modal}
      show={!!modalContent}
      closeButton={isFeedback}
      onHide={onHide}
    >
      {isFeedback ? (
        <div>
          <p className={styles.followupQuestion}>{followupQuestion}</p>
          <TextArea
            className={styles.textArea}
            ariaLabel={`Type ${followupQuestion}`}
            onChange={setFollowupAnswer}
            onEnter={onSubmit}
            value={followupAnswer}
            maxLength={MAX_ANSWER_LENGTH}
          />
          <Button
            className={styles.submitButton}
            ariaLabel={translations.submitSatisfactionFormAriaLabel}
            onClick={onSubmit}
          >
            {translations.submitSatisfactionSubmitButton}
          </Button>
        </div>
      ) : (
        <div>
          <CheckCircleIcon class={styles.checkCircleIcon} />
          <p>{translations.satisfactionMessageModalFeedback}</p>
          <Button
            className={styles.doneButton}
            ariaLabel={translations.done}
            onClick={onHide}
          >
            {translations.done}
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default SatisfactionMessageModal;
